<template>
  <div style="position: sticky; top: 0; z-index: 100;">
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" :color="appColor" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- OFFICERS -->
    <!-- <v-navigation-drawer
      v-if="
        appRole == 'range' ||
        appRole == 'division' ||
        appRole == 'EmergencyUser' ||
        appRole == 'RRT'
      "
      v-model="sideNav"
      fixed
      temporary
      width="200px"
      class="hidden-md-and-up"
      color="#FAFAFA"
    >
      <v-layout wrap justify-center>
        <v-flex xs12 text-center>
          <Logo />
        </v-flex>
        <v-flex xs12 text-center pa-2 pl-4 text-uppercase align-self-center>
          <v-list dense nav>
            <v-list-item
              v-for="item in items"
              :key="item.title"
              link
              :to="item.path"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-flex>
      </v-layout>
    </v-navigation-drawer> -->








    <!-- SIDENAV -->
    <v-navigation-drawer v-model="sideNavRight" right fixed temporary width="220px" class="hidden-md-and-up"
      color="#FAFAFA">
      <v-layout wrap>
        <v-flex v-for="(item, i) in headerItems" :key="i" xs12 text-center>
          <v-layout wrap>
            <v-flex xs12 @click="changeRoute(item)" :class="$route.query.id == item.nameValue
              ? 'appHeaderActiveClass'
              : 'appHeaderNormalClass' &&
                !$route.query.id &&
                item.nameValue == 'activeCases'
                ? 'appHeaderActiveClass'
                : 'appHeaderNormalClass'
              " style="
                text-decoration: none;
                cursor: pointer;
                letter-spacing: 0px;
              ">
              <span :class="$vuetify.breakpoint.name == 'md'
                ? 'font-size-md'
                : 'font-size-other'
                ">
                {{ item.title }}:
              </span>
              <v-btn color="#ededed" elevation="0" width="25px" height="23px" fab><span class="pa-1"
                  style="color: #000; font-size: 10px">{{
                    item.value
                  }}</span>
              </v-btn>
            </v-flex>
            <v-flex xs12 pt-3>
              <v-progress-linear height="5px" v-if="
                $route.query.id == item.nameValue ||
                (!$route.query.id && item.nameValue == 'activeCases')
              " value="100" color="#ededed"></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <!-- APPHEADER -->
    <v-app-bar style="position: sticky; top: 0; z-index: 100; backdrop-filter: blur(8px);" color="#ffffff" dense flat class="hidden-md-and-up px-4">
      <v-app-bar-nav-icon @click.stop="toggleDrawer">
        <v-icon color="#000">mdi-menu</v-icon>
      </v-app-bar-nav-icon>

      <v-spacer></v-spacer>

      <div class="d-flex align-center justify-center" style="max-width: 60%; flex: 1;">
        <div class="header-logo-container">
          <img 
            :src="require('./../../assets/mpgovernment.png')" 
            alt="GOVERNMENT OF MP" 
            class="header-gov-icon"
          />
          <span class="header-gov-text">GOVERNMENT OF MP</span>
        </div>
      </div>

      <v-spacer></v-spacer>

      <div v-if="appLogin" style="width: 48px; display: flex; justify-content: flex-end; align-items: center;">
        <AccountMenu />
      </div>
      <div v-else style="width: 48px;"></div>
    </v-app-bar>

    <v-app-bar style="position: sticky; top: 0; z-index: 100; padding-left: 0px !important; backdrop-filter: blur(8px);" color="#ffffff" dense flat class="hidden-sm-and-down" height="60px">
      <v-layout wrap align-center style="width: 100%;">
        <!-- Left spacer to perfectly balance the account menu on the right -->
        <v-flex xs3 md3 lg3></v-flex>

        <!-- Centered Logo and Text -->
        <v-flex xs6 md6 lg6 class="d-flex justify-center align-center">
          <div class="header-logo-container">
            <img 
              :src="require('./../../assets/mpgovernment.png')" 
              alt="GOVERNMENT OF MP" 
              class="header-gov-icon"
            />
            <span class="header-gov-text">GOVERNMENT OF MP</span>
          </div>
        </v-flex>

        <!-- Right Account Menu -->
        <v-flex xs3 md3 lg3 class="d-flex justify-end pr-4" v-if="appLogin">
          <AccountMenu />
        </v-flex>
        <v-flex xs3 md3 lg3 v-else></v-flex>
      </v-layout>
    </v-app-bar>
  </div>
</template>
<script>
//WILDWATCH
import axios from "axios";
import AccountMenu from "./accountMenu";
// import AppNotifications from "@/views/Notifications/appNotification";
import Socket from "./../../Sockets/socket";

export default {
  components: {
    // AppNotifications,
    AccountMenu,
  },
  data() {
    return {
      activeSection: localStorage.getItem('activeSection') || 'hwc',
      ServerError: false,
      msg: null,
      showSnackBar: false,
      timeout: 5000,
      searchKey: this.$route.query.searchKey
        ? this.$route.query.searchKey
        : null,
      sideNavRight: false,
      adminItems: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/Admin/admindashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/Admin/profile" },
        { title: "Public", icon: "mdi-account-group", path: "/Admin/public" },
        {
          title: "Conflict Reports",
          icon: "mdi-source-repository-multiple",
          path: "/Admin/ConflictReports",
        },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/admin/analytics",
        },
        {
          title: "Add Emergency User",
          icon: "mdi-account-plus",
          path: "/Admin/emergencyUser",
        },
        {
          title: "Notifications",
          icon: "mdi-bell",
          path: "/Admin/notifications",
        },
        {
          title: "All Reportings",
          icon: "mdi-file-chart",
          path: "/Admin/myReport",
        },
        {
          title: "Closed Cases",
          icon: "mdi-close",
          path: "/Admin/closedcases",
        },
      ],
      report: {
        title: "Dynamic Data",
        icon: "mdi-folder",
        visible: false,
        reportItems: [
          {
            title: "Scenerios",
            path: "/Admin/dynamicData/scenerios",
          },
          {
            title: "Animals",
            path: "/Admin/dynamicData/animals",
          },
          {
            title: "Animal Activities",
            path: "/Admin/dynamicData/animalActivities",
          },
          {
            title: "Animal Status",
            path: "/Admin/dynamicData/animalStatus",
          },
          {
            title: "Mitigations",
            path: "/Admin/dynamicData/mitigationTypes",
          },
          {
            title: "Land Types",
            path: "/Admin/dynamicData/landTypes",
          },
          {
            title: "Gender",
            path: "/Admin/dynamicData/gender",
          },
          {
            title: "Breach Types",
            path: "/Admin/dynamicData/breachType",
          },
          {
            title: "Barrier Types",
            path: "/Admin/dynamicData/barrierType",
          },
          {
            title: "Conflict Types",
            path: "/Admin/dynamicData/conflictType",
          },
          {
            title: "Crop Types",
            path: "/Admin/dynamicData/cropType",
          },
        ],
      },

      dynamic: [
        {
          title: "Dynamic Data",
          icon: "mdi-folder",
          visible: false,
          items: [
            {
              title: "Scenerios",
              path: "/Admin/dynamicData/scenerios",
            },
            {
              title: "Animals",
              path: "/Admin/dynamicData/animals",
            },
            {
              title: "Animal Activities",
              path: "/Admin/dynamicData/animalActivities",
            },
            {
              title: "Animal Status",
              path: "/Admin/dynamicData/animalStatus",
            },
            // {
            //   title: "Animal Age",
            //   path: "/Admin/dynamicData/animalAge",
            // },
            // {
            //   title: "Veterinary Recommendation",
            //   path: "/Admin/dynamicData/veterinaryRecommendation",
            // },
            {
              title: "Mitigations",
              path: "/Admin/dynamicData/mitigationTypes",
            },
            {
              title: "Land Types",
              path: "/Admin/dynamicData/landTypes",
            },
            {
              title: "Gender",
              path: "/Admin/dynamicData/gender",
            },
            // {
            //   title: "Close Status",
            //   path: "/Admin/dynamicData/closeStatus",
            // },
            // {
            //   title: "Release Types",
            //   path: "/Admin/dynamicData/releaseTypes",
            // },
            {
              title: "Breach Types",
              path: "/Admin/dynamicData/breachType",
            },
            {
              title: "Barrier Types",
              path: "/Admin/dynamicData/barrierType",
            },
            {
              title: "Conflict Types",
              path: "/Admin/dynamicData/conflictType",
            },
            {
              title: "Crop Types",
              path: "/Admin/dynamicData/cropType",
            },
          ],
        },
      ],
      sarpa: {
        title: "SARPA",
        icon: "mdi-snake",
        visible: false,
        sarpaItems: [
          {
            title: "Dashboard",
            path: "/Sarpa/dashboard",
          },
          {
            title: "Add Snakes",
            path: "/addSnakes",
          },
          {
            title: "All Users",
            path: "/usersList",
          },
          {
            title: "New Rescuers",
            path: "/newrescuerslist",
          },
          {
            title: "Rescuer List",
            path: "/allrescuerlist",
          },
          {
            title: "Pending Operations",
            path: "/pendingoperations",
          },
          {
            title: "Assigned Operations",
            path: "/assignedoperations",
          },
          {
            title: "Rescued Operations",
            path: "/rescuedoperations",
          },
          {
            title: "Released Operations",
            path: "/releasedoperations",
          },
          {
            title: "Approved Operations",
            path: "/approvedoperations",
          },
          {
            title: "Delete Operations",
            path: "/deleteoperations",
          },
          {
            title: "Training List",
            path: "/traininglist",
          },
          {
            title: "Snake Reports",
            path: "/snakereports",
          },
          // {
          //   title: "Add Snake Experts",
          //   path: "/addsnakeexperts",
          // },
          {
            title: "Add Hospital",
            path: "/addhospital",
          },
          {
            title: "View Hospital",
            path: "/Viewhospital",
          },
          {
            title: "Identification Help",
            path: "/identificationhelp",
          },
          {
            title: "Approve Hospital",
            path: "/approvehospital",
          },
        ],
      },

      //   {
      //     title: "Dashboard",
      //     icon: "mdi-view-dashboard",
      //     path: "/Officers/dashboard",
      //   },
      //   {
      //     title: "My Details",
      //     icon: "mdi-account",
      //     path: "/Officers/myDetails",
      //   },
      //   { title: "Teams", icon: "mdi-account-group", path: "/Officers/teams" },
      //   { title: "Forms", icon: "mdi-form-select", path: "/Officers/forms" },
      //   {
      //     title: "Notifications",
      //     icon: "mdi-bell",
      //     path: "/Officers/notifications",
      //   },
      //   {
      //     title: "Officers",
      //     icon: "mdi-account-circle",
      //     path: "/Officers/officers",
      //   },
      //   {
      //     title: "Merge Cases",
      //     icon: "mdi-call-merge",
      //     path: "/Officers/mergeCases",
      //   },
      //   {
      //     title: "Analytics",
      //     icon: "mdi-home-analytics",
      //     path: "/Officers/analytics",
      //   },
      // ],
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
      ],
      headerItems: [
        {
          title: "Active Cases",
          value: 0,
          path: "/?id=activeCases",
          nameValue: "activeCases",
        },

        {
          title: "Assigned Cases",
          value: 0,
          path: "/?id=assignedCases",
          nameValue: "assignedCases",
        },
        {
          title: "Resolved Cases",
          value: 0,
          path: "/?id=resolvedCases",
          nameValue: "resolvedCases",
        },
        {
          title: "Released Cases",
          value: 0,
          path: "/?id=releasedCases",
          nameValue: "releasedCases",
        },
      ],
      analytics: {},
      mergeValue: null,

      // socket Variables
      // role: null,
      socketType: null,
      newData: {},
      activeCasesvalue: "",
      assignedCasesvalue: "",
      resolvedCasesvalue: "",
    };
  },
  // beforeMount() {
  //   if (this.searchKey) this.appSearch();
  //   else this.getData();
  // },
  mounted() {
    this.socketData();
    if (this.appRole == "admin") {
      console.log("first", this.newData);
      this.assignAnalytics(this.newData);
    }
    // this.getSearch()
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
    appUser() {
      return this.$store.state.userName;
    },

    appUserrole() {
      return this.$store.state.userRole;
    },
    appRole() {
      return this.$store.state.userRole;
    },
    counterData() {
      return this.$store.state.counterData;
    },
    appNotification() {
      if (this.$store.state.notification == undefined) {
        return 0;
      } else {
        return this.$store.state.notification;
      }
    },
  },
  watch: {
    counterData: {
      handler: function () {
        // console.log(this.storage);
        this.assignAnalytics(this.counterData);
      },
      deep: true,
    },
    // searchKey() {
    //   this.assignAnalytics(this.counterData);
    // },
    // role() {
    //   if (this.role == "official") {
    //     this.assignAnalytics(this.newData)
    //   }
    // },
    //  socketType() {
    //   if (this.socketType == "resolveReport"|| this.socketType == "reportRelease") {
    //     this.assignAnalytics(this.newData)
    //   }
    // },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.isConnected = true;
    },

    disconnect() {
      this.isConnected = false;
    },

    // Fired when the server sends something on the "messageChannel" channel.
    messageChannel(data) {
      this.socketMessage = data;
    },
  },
  methods: {
    appLogout() {
      this.$store.commit("logoutUser", true);
    },
    toggleDrawer() {
      this.$store.commit('toggleSideNav');
    },
    // loadData() {
    //   var newData = {};
    //   newData = this.counterData;
    //   console.log(newData, "newData");
    //   this.assignAnalytics(newData);
    // },

    assignAnalytics(analytics) {
      if (analytics.activeCases > 0) {
        this.headerItems[0].value = analytics.activeCases;
      }
      else {
        this.headerItems[0].value = 0;
      }
      if (analytics.assignedCases > 0) {
        this.headerItems[1].value = analytics.assignedCases;
      }
      else {
        this.headerItems[1].value = 0;
      }
      if (analytics.resolvedCases > 0) {
        this.headerItems[2].value = analytics.resolvedCases;
      }
      else {
        this.headerItems[2].value = 0;
      }
      if (analytics.releasedCases > 0) {
        this.headerItems[3].value = analytics.releasedCases;
      }
      else {
        this.headerItems[3].value = 0;
      }
    },
    socketData() {
      Socket.countFunction(this); // <---read data
    },
    //WILDWATCH
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dashboard",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.analytics = response.data.count;
            this.$store.commit("counterData", response.data.count);
            this.assignAnalytics(this.analytics);
            this.$store.commit(
              "changeNotification",
              response.data.unreadNotification
            );
            this.mergeValue = this.analytics.mergeSuggestion;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;

          this.appLoading = false;
          console.log(err);
        });
    },
    getDatasearchKey() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/dashboard",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          searchKey: this.searchKey
        }

      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.analytics = response.data.count;
            this.$store.commit("counterData", response.data.count);
            this.assignAnalytics(this.analytics);
            this.$store.commit(
              "changeNotification",
              response.data.unreadNotification
            );
            this.mergeValue = this.analytics.mergeSuggestion;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;

          this.appLoading = false;
          console.log(err);
        });
    },
    changeRoute(item) {
      if (this.$store.state.userRole == "admin") {
        this.$router.push({
          path: "/admin/adminDashboard",
          query: {
            id: this.$route.query.id != item.nameValue ? item.nameValue : null,
            searchKey: this.$route.query.searchKey,
          },
        });
      } else if (
        this.$store.state.userRole == "official" ||
        this.$store.state.userRole == "range" ||
        this.$store.state.userRole == "division" ||
        this.$store.state.userRole == "EmergencyUser" ||
        this.$store.state.userRole == "RRT"
      ) {
        this.$router.push({
          path: "/officers/dashboard",
          query: {
            id: this.$route.query.id != item.nameValue ? item.nameValue : null,
            searchKey: this.$route.query.searchKey,
          },
        });
      }
    },
    appSearch() {
      if (this.$route.query.searchKey == this.searchKey) return;
      this.$router.push({
        path: "",
        query: {
          id: this.$route.query.id,
          searchKey: this.searchKey,
        },
      });
      this.getDatasearchKey();
    },
  },
};
</script>

<style>
.appHeaderActiveClass {
  font-family: sofiaProSemiBold;
  color: #000 !important;
}

.appHeaderNormalClass {
  font-family: sofiaProRegular;
  color: #838383 !important;
}

.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 0px !important;
}

.font-size-md {
  font-size: 12px;
}

.font-size-other {
  font-size: 16px;
}

/* Responsive Sidebar (Mobile) styling */
.responsive-sidebar {
  background: linear-gradient(135deg, #fff5f0 10%, #ffcfb8 100%) !important;
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.02) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.06) !important;
}

/* Hide scrollbar in mobile sidebar list */
.responsive-sidebar ::v-deep .v-list::-webkit-scrollbar {
  width: 0px !important;
  height: 0px !important;
  background: transparent !important;
}

.responsive-sidebar ::v-deep .v-list {
  overflow-y: auto !important;
  -ms-overflow-style: none !important;
  scrollbar-width: none !important;
  background: transparent !important;
}

.logo-container {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
  width: 100%;
  background: transparent !important;
}

.nav-item {
  position: relative;
  border-radius: 12px !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  margin-bottom: 8px !important;
  padding: 0 16px !important;
  overflow: hidden;
}

.nav-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10%;
  height: 80%;
  width: 4px;
  background: #de520c;
  border-radius: 0 4px 4px 0;
  transform: scaleY(0);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 2;
}

.nav-item:hover {
  background: rgba(222, 82, 12, 0.08) !important;
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(222, 82, 12, 0.05) !important;
}

.nav-icon {
  color: #64748b !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.nav-title {
  color: #334155 !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.nav-item:hover .nav-icon,
.nav-item:hover .nav-title {
  color: #de520c !important;
}

/* Active State Highlighting */
.active-nav-item {
  background: linear-gradient(135deg, #de520c, #b83e05) !important;
  box-shadow: 0 8px 20px rgba(222, 82, 12, 0.2), 0 4px 8px rgba(222, 82, 12, 0.1) !important;
  transform: translateX(6px);
}

.active-nav-item::before {
  transform: scaleY(1);
  background: #ffffff;
  /* Contrast on active item */
}

.active-nav-item .nav-icon,
.active-nav-item .nav-title {
  color: #ffffff !important;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.header-gov-icon {
  width: 68px !important;
  height: 68px !important;
  object-fit: contain;
  margin-left: -14px !important;
  margin-right: -14px !important;
  flex-shrink: 0;
}

.header-gov-text {
  font-family: 'poppinsmedium', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #000000 !important;
  letter-spacing: 0.5px;
}

@media (max-width: 599px) {
  .header-gov-text {
    font-size: 14px;
  }
  .header-gov-icon {
    width: 56px !important;
    height: 56px !important;
    margin-left: -12px !important;
    margin-right: -12px !important;
  }
}
</style>
